import { useState } from "react";
import { useLocation } from "react-router-dom";

/**
 * Navigation state for Back buttons: the screen we return to shows the choice
 * made on it earlier. Going forward never sets it, so screens start empty.
 *
 *   navigate("/choose-avatar", RESTORE_SELECTION);
 */
export const RESTORE_SELECTION = { state: { restoreSelection: true } } as const;

/**
 * Selection state for a choice screen: starts empty, or with the value saved
 * under `storageKey` when the screen was reached via a Back button.
 */
export const useRestorableSelection = (storageKey: string) => {
  const location = useLocation();
  const restore = Boolean(
    (location.state as { restoreSelection?: boolean } | null)?.restoreSelection
  );
  return useState(() => (restore ? localStorage.getItem(storageKey) ?? "" : ""));
};
